import React from 'react';
import {BrowserRouter as Router, Route, Routes} from 'react-router-dom';
import {useSelector} from 'react-redux';
import {createTheme, makeStyles, MuiThemeProvider} from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import backgroundImage from '../../assets/images/faq-tile.png';
import Header from './shared/header/Header';
import LoadingModal from './shared/loadingmodal/LoadingModal';
import GlobalDialogMessage from './shared/dialogmessage/GlobalDialogMessage';
import {BASE_NAME} from '../constants';
import Footer from "./shared/footer/Footer";
import PageNaoEncontrada from "./PageNaoEncontrada";
import ConfirmationDialogProvider from "./shared/confirmationdialog/ConfirmationDialogProvider";
import PageHome from "./PageHome";

const newTheme = createTheme({
    typography: {
        useNextVariants: true
    },
    palette: {
        primary: {
            main: '#20356C'
        },
        secondary: {
            main: '#D2D7E2'
        },
        tertiary: {
            light: '#53b0f9',
            main: '#1672bb',
            dark: '#074b81'
        }
    },
    breakpoints: {
        values: {
            xs: 0,
            sm: 800, // Alterado de 600 para 800
            md: 960,
            lg: 1280,
            xl: 1920
        },
    },
});

const useStyles = makeStyles(theme => ({
    '@global': {
        'html, body, #root': {
            height: '100%',
            '-webkit-overflow-scrolling': 'touch',
        },
        html: {
            background: '#ecedf1 url(' + backgroundImage + ') 0 0 repeat',
            backgroundAttachment: 'fixed'
        },
        body: {
            background: '#ecedf1 url(' + backgroundImage + ') 0 0 repeat'
        },
        'ul, ol': {
            margin: 0,
            padding: 0,
            listStyle: 'none'
        },
        a: {
            textDecoration: 'underline'
        },
        p: {
            marginTop: 0
        },
        '#root': {
            height: '100%'
        }
    },
    gridContainer: {
        minHeight: '100%',
        display: 'grid',
        gridTemplateRows: 'min-content 1fr min-content'
    },
}));

export default function App() {
    const classes = useStyles();
    const showHeader = useSelector(state => state.showHeader);

    return (
        <Router basename={BASE_NAME}>
            <>
                <CssBaseline />
                <MuiThemeProvider theme={newTheme}>
                    <ConfirmationDialogProvider>
                        <LoadingModal />
                        <GlobalDialogMessage />
                        <div className={classes.gridContainer}>
                            {showHeader && (
                                <Header
                                    title='Boleto Negociação'
                                    subtitle='Portal Unaerp' />
                            )}
                            <main>
                                <Routes>
                                    <Route path='/*' element={<PageHome />} />
                                    <Route path='/pagina-nao-encontrada' element={<PageNaoEncontrada />} />
                                </Routes>
                            </main>
                            <Footer />
                        </div>
                    </ConfirmationDialogProvider>
                </MuiThemeProvider>
            </>
        </Router>
    );
}